import script from "./IbRecord.vue?vue&type=script&lang=ts&setup=true"
export * from "./IbRecord.vue?vue&type=script&lang=ts&setup=true"

import "./IbRecord.vue?vue&type=style&index=0&id=641cc3ac&scoped=true&lang=css"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-641cc3ac"]])

export default __exports__